import { z } from "zod";

export const loginSchema = z.object({
  email: z.email("Enter a valid email address."),
  password: z.string().min(1, "Password is required."),
});

export const signupSchema = z
  .object({
    role: z.enum(["broker", "developer", "sales_team"], {
      errorMap: () => ({ message: "Please select a role." }),
    }),
    email: z.email("Enter a valid email address."),
    phoneCountry: z.string().min(1),
    phone: z
      .string()
      .trim()
      .min(7, "Phone number is too short.")
      .max(15, "Phone number is too long.")
      .regex(/^[0-9]+$/, "Use digits only."),
    reraCertificate: z
      .any()
      .refine((file) => !file || file instanceof File, "Please upload a valid file")
      .refine((file) => !file || file.size <= 5 * 1024 * 1024, "File size must be less than 5 MB")
      .refine((file) => !file || file.type === "application/pdf", "Only PDF files are accepted")
      .refine((file) => !file || file.name.toLowerCase().endsWith(".pdf"), "File must have a .pdf extension"),
    password: z.string().min(6, "Password must be at least 6 characters."),
    passwordConfirmation: z.string().min(1, "Please confirm your password."),
  })
  .refine((v) => v.password === v.passwordConfirmation, {
    message: "Passwords do not match.",
    path: ["passwordConfirmation"],
  })
  .superRefine((data, ctx) => {
    if (["broker", "developer"].includes(data.role) && !data.reraCertificate) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: "RERA certificate is required for brokers and developers.",
        path: ["reraCertificate"],
      });
    }
  });

export const phoneSchema = z.string().regex(/^\+[1-9]\d{1,14}$/, "Must be a valid E.164 phone number (e.g. +1234567890)");
export const otpSchema = z.string().length(6, "OTP must be exactly 6 digits").regex(/^\d+$/, "OTP must contain only numbers");

export const phoneFormSchema = z.object({
  phone: phoneSchema,
});

export const otpFormSchema = z.object({
  otp: otpSchema,
});

